import { reactive } from 'vue';

export const criarPerfil = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdperfil: 0,
        nmperfil: '',
        informacoes: '',
        ativo: 'S',
        idlogin: 0
    });
};